var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, VueType } from '../../core';
import { Prop } from 'vue-property-decorator';
import './cornerMark.style.scss';
const FONT_SIZE_MAP = {
    medium: 12,
    small: 10,
    bigger: 15,
};
let CornerMark = class CornerMark extends VueType {
    get classes() {
        return ['corner-wrap', `corner-mark--${this.size}`, `corner-mark--${this.position}`].join(' ');
    }
    get cornerStyle() {
        var _a, _b;
        return {
            color: ((_a = this.data) === null || _a === void 0 ? void 0 : _a.font_color) || "#FFF" /* FONT_COLOR_NORMAL */,
            backgroundColor: (_b = this.data) === null || _b === void 0 ? void 0 : _b.background_color,
            size: `${FONT_SIZE_MAP[this.size]}px`,
        };
    }
    render() {
        return <div class={this.classes} style={this.cornerStyle}>
      {this.data.font_image_url && <img src={this.data.font_image_url} class="img"/>}
      {this.data.text && <span class="text">{this.data.text}</span>}
    </div>;
    }
};
__decorate([
    Prop()
], CornerMark.prototype, "data", void 0);
__decorate([
    Prop()
], CornerMark.prototype, "position", void 0);
__decorate([
    Prop()
], CornerMark.prototype, "size", void 0);
CornerMark = __decorate([
    Component
], CornerMark);
export default CornerMark;
